import React from 'react'

import success from '../../assets/preisrechner/svg/success.svg'
import phone from '../../assets/preisrechner/svg/phone.svg'
import mail from '../../assets/preisrechner/svg/mail.svg'

const Done = props => {
  return (
    <div className="step">
      <div className="vermFormContent">
        <div className="vermCenterContent">
        <p className="vermCenterContentP">Die Offerte ist in wenigen Sekunde<br></br>bei Ihnen im Posteingang.</p>
          <img className="success" src={success}/>
          <hr className="success-divider"/>
          <div className="question">
            <div className="question-title">
              Sie haben noch offene Fragen?
            </div>
            <div className="question-text">
              Melden Sie sich bei uns.<br/>
              Gerne helfen wir Ihnen dabei, Stolpersteine zu beseitigen.
            </div>
            <div className="contact-buttons">
              <a href="tel:tel:0041714774400" className="href"><img className="cta-phone" src={phone}/></a>
              <a href="mailto:info@vermflex.ch" className="href"><img className="cta-mail" src={mail}/></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Done